// extracted by mini-css-extract-plugin
export var cardBody = "bQ_fT";
export var cardContent = "bQ_fR";
export var cardFooter = "bQ_fS";
export var container = "bQ_b8";
export var gridCardAParent = "bQ_fV";
export var imageContainer = "bQ_bH";